import React, { useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
import clientimg from "../../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import {
  decryptString,
  getName,
  getTabStatus,
  goToClientDashboard,
  mobileNumber,
  noDataFound,
  splitDate,
} from "../../CommonMethhods/CommonMethods";
import Loader from "../../Components/Common/Loader";

function OnboardingRejected(props) {
  const cosmosRid = localStorage.getItem("cosmosRid");
  const { linecard, checkRejected } = props;
  let navigate = useNavigate();
  let serverError = props.serverError;

  const [show, setShow] = useState(false);
  const { selectedClient, setSelectedClient, handleRedirect } = props;

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = (client) => {
    setSelectedClient(client);
    setShow(true);
  };

   const panVal = selectedClient?.pan
    ? decryptString(selectedClient.pan)
    : "";
    const mobVal = selectedClient?.mobile
    ? decryptString(selectedClient.mobile)
    : "";
  

  return (
    <>
      <Tab.Pane eventKey="Rejected" className="rejectedClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center"
              onScroll={(e) => props.handleScroll(e)}
            >
              {checkRejected.length > 0 ? (
                <div
                  className={` ${
                    linecard === "block-active col-division-5"
                      ? "onboarding-card-wrapper"
                      : ""
                  }`}
                >
                  
                  {checkRejected.map((item, index) => {
                    const decryptedPan = item?.pan ? decryptString(item?.pan) : "";
                    const decryptedMobile = item?.mobile ? decryptString(item?.mobile) : "";

                      console.log(decryptedMobile, decryptedPan, "checkRejected");

                    return (
                      <div
                        className={`w-100 bottom-25 ${linecard}`}
                        key={index}
                      >
                        <div
                          style={{
                            cursor:
                              linecard === "block-active col-division-5"
                                ? "pointer"
                                : "default",
                          }}
                          onClick={() => {
                            if (linecard === "block-active col-division-5")
                              handleShow(item);
                          }}
                        >
                          <div
                            className="card-box onboarding-card d-flex justify-content-between"
                            style={{
                              cursor:
                                linecard === "block-active col-division-5"
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            <div className="client-img-checkbox-wrapper">
                              <div className="client-img-wrapper">
                                <div className="profile-image">
                                  {item?.clientname
                                    ? getName(item?.clientname)
                                    : "N.A"}
                                </div>
                              </div>
                            </div>
                            <div className="onboarding-card-content">
                              <div className="onboarding-card-top">
                                <div className="user-email-wrapper">
                                  <p className="username">
                                    <span>{item.clientname}</span>
                                  </p>{" "}
                                  <p className="email">
                                    {item?.emailid ? item?.emailid : "N.A"}
                                  </p>
                                </div>
                                {/* <ul className="onboarding-content-link-list">
                                  <li className="fingerprint-icon-wrapper">
                                    <span className="icon-fingerprint fingerprint-icon"></span>
                                  </li>
                                  <li className="user-icon-wrapper">
                                    <span className="icon-verified-user"></span>
                                  </li>
                                  <li className="onboard-new-link">
                                    <Link to="#" className="">
                                      {Constants.New}
                                    </Link>
                                  </li>
                                </ul> */}
                              </div>
                              <div className="clientname-info">
                                <ul className="call-web-wrapper justify-content-center">
                                  <li className="created-time-wrapper">
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {item?.createddatetime
                                          ? splitDate(item?.createddatetime)
                                          : "N.A"}
                                      </span>
                                    </span>
                                  </li>
                                  {/* <li className="created-time-wrapper">
                                    <span className="icon-client-code onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>{item.clientCode}</span>
                                    </span>
                                  </li> */}
                                </ul>

                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                         {decryptedMobile
                                            ? mobileNumber(decryptedMobile)
                                            : "N.A"}
                                          {/* {item?.mobile ? item?.mobile : "N.A"} */}
                                        </span>
                                      </span>
                                    </li>
                                    <li>
                                      <span className="icon-android onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {decryptedPan
                                            ? mobileNumber(decryptedPan)
                                            : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            {linecard !== "block-active col-division-5" && (
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ width: "100%", gap: "15px" }}
                              >
                                <div
                                  className="list-extra-details flex-grow-1 ms-4 w-100 mr-5"
                                  style={{ marginLeft: "-190px" }}
                                >
                                  <div className="row">
                                    {/* Rejected On */}
                                    <div className="col-3 border-right list-info-col">
                                      <p
                                        className="label mb-1 text-black"
                                        style={{ fontSize: "13px" }}
                                      >
                                        Rejected On
                                      </p>
                                      <p className="value mb-0 text-muted">
                                        {item?.createddatetime
                                          ? splitDate(item?.rejectionDate)
                                          : "N.A"}
                                      </p>
                                    </div>

                                    {/* Reject Type */}
                                    <div className="col-3 border-right list-info-col">
                                      <p
                                        className="label mb-1 text-black"
                                        style={{ fontSize: "13px" }}
                                      >
                                        Reject Type
                                      </p>
                                      <p className="value mb-0 text-muted">
                                        {item?.rejectionType || "N.A"}
                                      </p>
                                    </div>

                                    {/* Reject Reason */}
                                    <div className="col-6 text-left list-info-col">
                                      <p
                                        className="label mb-1 text-black"
                                        style={{ fontSize: "13px" }}
                                      >
                                        Reject Reason
                                      </p>
                                      <p className="value mb-0 text-muted">
                                        {item?.rejectionReason || "N.A"}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                {/* Edit Button */}
                                <div
                                  className="list-info-col ms-3"
                                  style={{ width: "15%" }}
                                >
                                  <Button
                                    className="no-focus"
                                    type="button"
                                    onClick={(e) => {
                                      handleRedirect(item);
                                    }}
                                    variant="outline-primary w-100"
                                    style={{
                                      height: "30px",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Edit
                                  </Button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                serverError && (
                  <h4 className="alert-title mb-0">
                    {noDataFound(serverError)}
                  </h4>
                )
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          {selectedClient && (
            <div
              style={{
                cursor: "default",
                userSelect: "text",
              }}
            >
              <div className="d-flex justify-content-between mb-5 mt-3">
                <div>
                  <h3>
                    <strong>Client Details</strong>
                  </h3>
                </div>
                <div>
                  <button
                    onClick={() => setShow(false)}
                    style={{ backgroundColor: "transparent" }}
                  >
                    <h3 className="mr-3">X</h3>
                  </button>
                </div>
              </div>

              <div className="d-flex align-items-center mb-3 ml-3 mr-2">
                <div className="w-100">
                  <div className="d-flex justify-content-between w-100 mb-1">
                    <div className="client-img-checkbox-wrapper mb-1">
                      <div className="client-img-wrapper">
                        <div className="profile-image">
                          {selectedClient?.clientname
                            ? getName(selectedClient?.clientname)
                            : "N.A"}
                        </div>
                      </div>
                    </div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      className="ml-auto mr-2 no-focus"
                      onClick={() => handleRedirect(selectedClient)}
                      style={{
                        width: "60px",
                        fontSize: "12px",
                        height: "30px",
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                  <h3 className="mb-0 text-primary">
                    {selectedClient.clientname || "N.A"}
                  </h3>
                  <span className="text-muted" style={{ fontSize: "11px" }}>
                    {selectedClient.emailid || "N.A"}
                  </span>
                </div>
              </div>

              <div
                className="d-flex justify-content-start mb-5  ml-3"
                style={{ fontSize: "11px", color: " #1a5da1ff" }}
              >
                <span
                  className="pr-1"
                  style={{ borderRight: "1px solid #1a5da1" }}
                >
                  {selectedClient.createddatetime
                    ? splitDate(selectedClient.createddatetime)
                    : "N.A"}
                </span>
                <span
                  className="pr-1 pl-1 "
                  style={{ borderRight: "1px solid #1a5da1" }}
                >
                  {(cosmosRid === "56" || cosmosRid === "53") ?
                                          mobVal || "N.A"
                                          : mobileNumber(mobVal) || "N.A"}
                  {/* {selectedClient.mobile || "N.A"} */}
                </span>
                <span className="pl-1">
                  {mobileNumber(panVal) || "N.A"}
                  {/* {selectedClient.pan || "N.A"} */}
                  </span>
              </div>

              <div className="row ml-1">
                <div className="col-sm-6">
                  <strong style={{ fontSize: "12px" }}>Rejected On</strong>
                  <p style={{ fontSize: "11px" }} className="text-muted">
                    {selectedClient.rejectionDate
                      ? splitDate(selectedClient.rejectionDate)
                      : "N.A"}
                  </p>
                </div>
                <div className="col-sm-6">
                  <strong style={{ fontSize: "12px" }}>Reject Type</strong>
                  <p style={{ fontSize: "11px" }} className="text-muted">
                    {selectedClient.rejectionType || "N.A"}
                  </p>
                </div>
              </div>

              <hr />
              <div className="ml-3 mb-3 mr-2">
                <strong style={{ fontSize: "12px" }}>Reject Reason</strong>
                <p style={{ fontSize: "11px" }} className="text-muted">
                  {selectedClient.rejectionReason || "N.A"}
                </p>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default OnboardingRejected;
